export const DEFAULT_COLOR_SCHEME = 'brand';
export const DEFAULT_TOAST_DURATION = 3000;
